import React, { useEffect } from "react"
import "./scrollup.css"

const ScrollUp = () => {

    useEffect(() => {
        const scrollUp = () => {
            const scrollBtn = document.getElementById("scroll-up");
            if (scrollBtn) {
                if (window.scrollY >= 560) scrollBtn.classList.add("show-scroll");
                else scrollBtn.classList.remove("show-scroll");
            }
        };
        window.addEventListener("scroll", scrollUp);
        return () => window.removeEventListener("scroll", scrollUp);
    }, []);

    return (
        <>
            <a
                onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                href="/"
                className="scrollup"
                id="scroll-up"
                aria-label="Scroll to top"
            >
                <i className="uil uil-arrow-up scrollup__icon" aria-hidden="true"></i>
            </a>
        </>
    )
}

export default ScrollUp
